import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Container, Row } from "react-bootstrap";
import { useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import * as Steps from './AppointmentSteps/Index';
import { HeaderStepper } from '../HeaderStepper/HeaderStepper';
import { getSessionStorageItem, SESSION_STORAGE_APPOINTMENT_KEY } from '../../../../sessionStorage';
import { saveSessionEvent } from "../../../../session";
import TimeZones from './Timezones';
import MCTProductDetails from "../../FullUW/Helpers/MCTProductDetails";
import { ProductSummary } from "../Appointment/AppointmentSteps/Index"
import './Appointment.scss';

export default function Appointment(props) {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => { saveSessionEvent() }, [location])

  const path = props.baseURL;
  const { selectedQuote } = props.quoter;

  const sessionStorageFormState = getSessionStorageItem(SESSION_STORAGE_APPOINTMENT_KEY);
  const prefill = location && location.search && location.search.toLowerCase().includes('prefill');
  const basicInfo = props.basicInfo;

  const newFormState = {
    currentStep: 1,
    pages: {
      scheduleAppointment: Steps.ScheduleAppointment.DefaultFormState(prefill, basicInfo),
      information: Steps.Information.DefaultFormState(prefill, basicInfo),
    },
  }

  const initialFormState = sessionStorageFormState || newFormState;

  const [formState, setFormState] = useState(initialFormState);

  // update the formState when the url path changes the step
  useEffect(() => {
    if (!path) {
      return;
    }

    const nextStep = steps.find(s => s.path === path);

    // prevent submitted app alterations
    if (!sessionStorageFormState && formState.currentStep === steps.length) {

      // if they are backing or directly going to another step, send them to product root
      if (formState.currentStep !== nextStep.step) {
        navigate(location);
      }
    }

    if (!nextStep) {
      return;
    }
    const newFormState = { ...formState, currentStep: nextStep.step };
    setFormState(newFormState);
  }, [path])

  const [percentage, setPercentage] = useState(0);

  useEffect(() => {
    if (formState.currentStep === 1) {
      if (props.formState.firstName !== '' && props.formState.lastName !== '' && props.formState.email !== '') {
        setPercentage(50)
      }
      else if ((props.formState.firstName !== '' && props.formState.lastName === '' && props.formState.email === '') || (props.formState.firstName === '' && props.formState.lastName !== '' && props.formState.email === '') || (props.formState.firstName === '' && props.formState.lastName === '' && props.formState.email !== '')) {
        setPercentage(16);
      }
      else if ((props.formState.firstName !== '' && props.formState.lastName !== '' && props.formState.email === '') || (props.formState.firstName === '' && props.formState.lastName !== '' && props.formState.email !== '') || (props.formState.firstName !== '' && props.formState.lastName === '' && props.formState.email !== '')) {
        setPercentage(33);
      }
    }
    else if (formState.currentStep === 2) {
      if (props.formState.specificAppt === 'asap') {
        setPercentage(50)
        props.formState.phoneNumber !== "" ? setPercentage(100) : null;
      }
      else {
        setPercentage(50)
        if (props.formState.specificApptDate !== '' && props.formState.specificApptTime !== '' && props.formState.phoneNumber !== '') {
          setPercentage(100)
        }
        else if ((props.formState.specificApptDate !== '' && props.formState.specificApptTime === '' && props.formState.phoneNumber === '') || (props.formState.specificApptDate === '' && props.formState.specificApptTime !== '' && props.formState.phoneNumber === '') || (props.formState.specificApptDate === '' && props.formState.specificApptTime === '' && props.formState.phoneNumber !== '')) {
          setPercentage(66);
        }
        else if ((props.formState.specificApptDate !== '' && props.formState.specificApptTime !== '' && props.formState.phoneNumber === '') || (props.formState.specificApptDate === '' && props.formState.specificApptTime !== '' && props.formState.phoneNumber !== '') || (props.formState.specificApptDate !== '' && props.formState.specificApptTime === '' && props.formState.phoneNumber !== '')) {
          setPercentage(82);
        }
      }
    }
  }, [props.formState, formState.currentStep])

  const onNext = () => {

    const nextStep = steps.find(s => s.step === formState.currentStep + 1);

    const newFormState = { ...formState, currentStep: nextStep.step };

    setFormState(newFormState);
    sessionStorage.setItem(SESSION_STORAGE_APPOINTMENT_KEY, JSON.stringify(newFormState));

    navigate(`${props.baseURL}/${nextStep.path}`);
    window.scroll(0, 0);
  }

  const onBack = () => {
    const backStep = steps.find(s => s.step === formState.currentStep - 1);

    const newFormState = { ...formState, currentStep: backStep.step };

    setFormState(newFormState);
    sessionStorage.setItem(SESSION_STORAGE_APPOINTMENT_KEY, JSON.stringify(newFormState));

    navigate(`${props.baseURL}/${backStep.path}`);
    window.scroll(0, 0);
  }

  const handleTimeZone = (value) => {
    props.formState.timeZone = value;
  }

  const calcOptionStars = (score) => {
    if (score < 3) {
      return 0
    }
    if (score < 6.3) {
      return 0.5
    }
    if (score < 12.3) {
      return 1
    }
    if (score < 18.3) {
      return 1.5
    }
    if (score < 24.3) {
      return 2
    }
    if (score < 27.3) {
      return 2.5
    }
    return 3
  }

  const steps = [
    {
      step: 1,
      path: 'basic-info-appointment',
      progressTitle: '',
      component: (
        <Steps.Information
          formState={props.formState}
          basicInfo={basicInfo}
          quoter={props.quoter}
          onFieldChange={(field, value) => props.onFieldChange(field, value)}
          setFormState={props.setFormState
          }
          onNext={onNext}
          onBack={props.onBack}
          product={props.product}
          isAppointmentSchedulingEnabled={props.isAppointmentSchedulingEnabled}
          setMultiField={props.setMultiField}
        />
      ),
      categoryNumber: 1,
      showContainer: true,
    },
    {
      step: 2,
      path: 'appointment-details',
      progressTitle: '',
      component: (
        <Steps.ScheduleAppointment
          formState={props.formState}
          quoter={props.quoter}
          basicInfo={basicInfo}
          onFieldChange={(field, value) => props.onFieldChange(field, value)}
          setFormState={props.setFormState}
          journeyType={props.journeyType}
          onNext={props.onNext}
          onBack={onBack}
          product={props.product}
          isAppointmentSchedulingEnabled={props.isAppointmentSchedulingEnabled}
          handleTimeZone={handleTimeZone}
          fullFormState={props.fullFormState}
          onMultiFieldChange={props.onMultiFieldChange}
        />
      ),
      categoryNumber: 2,
      showContainer: true,
    }
  ];

  const currentStepObj = steps.find(s => s.step === formState.currentStep) || steps[0];

  return (
    <div>
      <Helmet>
        <title>{`Appointment`}</title>
      </Helmet>
      <HeaderStepper
        title={formState.currentStep === 1 ? 'Life Insurance Request' : 'Completing Your Coverage'}
        hidden={props.landing}
        hideProgressTracker={currentStepObj.hideProgressTracker}
        stepName={currentStepObj.progressTitle}
        step={formState.currentStep}
        totalSteps={2}
        percent={percentage}
      >
        <div className="MCT">
          <Container className="appointment-info py-4">
            <Row>
              <ProductSummary
                selectedQuote={selectedQuote}
                title={props.summaryTitle}
                product={props.product}
                coverageAmount={props.quoter.coverageAmount}
                carrier={props.quoter.carrierName}
                termLength={props.quoter.term}
                premium={props.quoter.premium}
                basicInfo={props.basicInfo}
                hideInMobile={formState.currentStep === 2 ? true : false}
                carrierName={selectedQuote && selectedQuote.carrierName}
                productName={selectedQuote && selectedQuote.productName}
                val={selectedQuote && selectedQuote.termLength}
                annualRate={selectedQuote && selectedQuote.annualRate}
                monthlyRate={selectedQuote && selectedQuote.monthlyRate}
                logoUrl={selectedQuote && selectedQuote.logoUrl}
                rating={selectedQuote && selectedQuote.rating}
                additionalOptionsStars={calcOptionStars(selectedQuote && selectedQuote.optionsScore)}
                requiresMedicalExam={selectedQuote && selectedQuote.requiresMedicalExam}
                underwritingTimeTypical={selectedQuote && selectedQuote.underwritingTimeTypical}
                hideSelect={true}
                onClick={() => {
                  console.log("Onclick")
                }}
                productDetails={
                  <MCTProductDetails
                    carrierName={selectedQuote && selectedQuote.carrierName}
                    productDescription={(selectedQuote && selectedQuote.productDescription) || ""}
                    selectedQuoteRanges={selectedQuote && selectedQuote.productRanges}
                    hasPermConversion={selectedQuote && selectedQuote.hasConvertibility}
                    productInformation={selectedQuote && selectedQuote.productInformation}
                  />
                }
                isBestPrice={selectedQuote && selectedQuote.isBestPrice}
                isFastest={selectedQuote && selectedQuote.isFastest}
                isMostOptions={selectedQuote && selectedQuote.isMostOptions}
                ratingAMBest={selectedQuote && selectedQuote.ratingAMBest}
                ratingSP={selectedQuote && selectedQuote.ratingSP}
                ratingMoodys={selectedQuote && selectedQuote.ratingMoodys}
                ratingFitch={selectedQuote && selectedQuote.ratingFitch}
                ratingComdex={selectedQuote && selectedQuote.ratingComdex}
                availableRiders={selectedQuote && selectedQuote.availableRiders}
                convertibility={selectedQuote && selectedQuote.convertibility}
                hasPermConversion={selectedQuote && selectedQuote.hasConvertibility}
                disclosure={selectedQuote && selectedQuote.disclosureDetail}
                healthClass={selectedQuote && selectedQuote.healthClass}
              />
              {currentStepObj.component}
            </Row>
          </Container>
        </div>
      </HeaderStepper>
    </div>
  );
}

Appointment.propTypes = {
  formState: PropTypes.object.isRequired,
  quoter: PropTypes.object.isRequired,
  basicInfo: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  isAppointmentSchedulingEnabled: PropTypes.bool.isRequired,
  fullFormState: PropTypes.object,
};

Appointment.DefaultFormState = (prefill = false, basicInfo = null) => {
  return {
    firstName: prefill ? 'Example' : (basicInfo && basicInfo.firstName) || '',
    lastName: prefill ? 'Consumer' : (basicInfo && basicInfo.lastName) || '',
    email: prefill ? 'user@address.com' : (basicInfo && basicInfo.email) || '',
    specificAppt: 'asap',
    timeZone: (function () {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const tz1 = TimeZones.find(e => e.zone === tz);
      return tz1 ? tz1.value : ''
    })(),
    specificApptDate: '',
    specificApptTime: '',
    phoneNumber: prefill ? '' : '',
    usResident: true,
  };
};
